import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AnimatedButton } from '@/components/ui/animated-button';

const faqs = [
  {
    question: 'Do you offer web design services for businesses in Qatar, the Middle East and the USA?',
    answer: 'Yes. We work from Doha with businesses across Qatar and the wider Middle East, as well as the USA and Europe. Everything is delivered remotely, so your location is not a constraint.'
  },
  {
    question: 'Can you help my business with local SEO?',
    answer: 'Absolutely. We offer small business digital solutions including local SEO to help you rank higher in your city or region.'
  },
  {
    question: 'What is digital branding and how can it help my business?',
    answer: 'Digital branding helps your business stand out online, build trust, and attract more customers through a cohesive visual and messaging strategy.'
  },
  {
    question: 'How long does it take to build a website?',
    answer: 'Most projects are completed within 2-4 weeks, depending on complexity and requirements.'
  },
  {
    question: 'Do you provide ongoing support after the website is launched?',
    answer: 'Yes, we offer ongoing support, updates, and maintenance for every client, wherever they are based.'
  }
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'mainEntity': faqs.map(faq => ({
    '@type': 'Question',
    'name': faq.question,
    'acceptedAnswer': {
      '@type': 'Answer',
      'text': faq.answer
    }
  }))
};

const FAQ = () => (
  <div className="min-h-screen pt-16 pb-24 bg-gradient-to-b from-primary/10 to-background dark:from-primary/5">
    <Helmet>
      <title>Frequently Asked Questions | Omnicraft Services</title>
      <meta name="description" content="Find answers to common questions about web design, SEO, software and AI services. Omnicraft Services works with small businesses across the USA, plus clients in Qatar and the Middle East." />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
    <section className="py-12">
      <div className="container-custom max-w-3xl mx-auto">
        <Badge className="mb-4 px-4 py-1 bg-primary/10 text-primary border-none">FAQ</Badge>
        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">Frequently Asked Questions</h1>
        <div className="space-y-6">
          {faqs.map((faq, idx) => (
            <Card key={idx} className="bg-white/90 dark:bg-slate-900/80 border border-primary/10 shadow-sm">
              <CardContent className="p-6">
                <h2 className="text-xl font-semibold mb-2 text-primary">{faq.question}</h2>
                <p className="text-slate-700 dark:text-slate-300">{faq.answer}</p>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-10 flex justify-center">
          <AnimatedButton 
            variant="secondary"
            onClick={() => window.location.href = '/contact'}
          >
            Still have questions? Contact Us
          </AnimatedButton>
        </div>
      </div>
    </section>
  </div>
);

export default FAQ; 